<div class="history-container">
  <div>
    <!--Header-->
    <div class="header mat-accent-bg p-16 p-sm-24">
      <div class="header-image">
        <!-- Header Image -->
        <img
          src="assets/images/logos/doc-connector-omni.png"
          style="z-index: 10000"
        />
      </div>
    </div>
  </div>

  <div>
    <div class="navigation-bar">
      <div class="navigation-text">
        <div style="width: 25px; display: inline-block">
          <mat-icon
            *ngIf="showSelectedLoanView"
            style="font-size: 14pt; color: #8883e2"
            (click)="clearSelectedLoan()"
            >arrow_back</mat-icon
          >
        </div>
        <a
          (click)="clearSelectedLoan(); exportButtonSwitch = !exportButtonSwitch;"
          class="history-a"
          [ngStyle]="showSelectedLoanView ? { color: '#8883e2' } : null"
          >History
        </a>
        <div *ngIf="showSelectedLoanView" class="loan-number-text">
          / {{ selectedLoan?.loanNumber }}
        </div>
        <div class="send-container px-8 px-mat-16">
          <div class="btn-container">
            <button 
            *ngIf="checkedFiles && checkedFiles.size > 0 && showSelectedLoanView"
             mat-button class="Btn-submit"
             (click)="onRetrySend($event)" 
             style="margin-right: 12px;"
             [disabled]="!checkedFiles || checkedFiles.size == 0"
            >
              Retry
            </button>
            <button 
              mat-button 
              class="Btn-submit" 
              (click)="refresh()" 
              [disabled]="isFetchingHistory"
              style="background-color: white; margin-right: 12px; border: 1px solid #ccc; font-size: 21px;"
              [matTooltip]="isFetchingHistory ? 'Loading...' : ''"
            >
            <i class="fa fa-refresh"></i>
          </button>
            <button mat-button class="Btn-submit" (click)="exportToCSVStatusReport()">
              Export Report
            </button>
        </div>
      </div>
    </div>
    <!-- History View -->
    <div
      class="history-table-section"
      [ngStyle]="{ display: showSelectedLoanView ? 'none' : 'inherit' }"
    >
      <div class="history-table-filter-container">
        <mat-form-field class="filter-form-field">
          <input
            matInput
            class="filter-input"
            [(ngModel)]="filterSearchText"
            placeholder="Filter Search"
            (keyup)="applyFilter($any($event.target).value)"
            (keyup.esc)="clearSearchData()"
            #filterSearch
          />
        </mat-form-field>
        
        <!-- Search limit warning -->
        <div *ngIf="searchLimitReached" style="color: #ff9800; font-style: italic; padding: 8px 16px; background-color: #fff3e0; border-left: 4px solid #ff9800; margin-bottom: 8px;">
          <mat-icon style="vertical-align: middle; font-size: 18px; height: 18px; width: 18px; margin-right: 4px;">warning</mat-icon>
          Search result limit reached (500 records). Some results may not be displayed. Please refine your search.
        </div>
        
        <!-- Fetching to end notification with cancel button -->
        <div *ngIf="isFetchingToEnd" style="color: #2196F3; font-style: italic; padding: 8px 16px; background-color: #E3F2FD; border-left: 4px solid #2196F3; margin-bottom: 8px; display: flex; align-items: center; justify-content: space-between;">
          <div>
            <mat-icon style="vertical-align: middle; font-size: 18px; height: 18px; width: 18px; margin-right: 4px;">cloud_download</mat-icon>
            Fetching all records (up to {{ FETCH_TO_END_BATCH_LIMIT }} per batch)...
          </div>
          <button mat-stroked-button color="warn" (click)="cancelFetchToEndOperation()" style="margin-left: 16px;">
            Cancel
          </button>
        </div>
        
        <!-- More records available notification -->
        <div *ngIf="showMoreRecordsAvailable && !isFetchingToEnd" style="color: #4CAF50; font-style: italic; padding: 8px 16px; background-color: #E8F5E9; border-left: 4px solid #4CAF50; margin-bottom: 8px;">
          <mat-icon style="vertical-align: middle; font-size: 18px; height: 18px; width: 18px; margin-right: 4px;">info</mat-icon>
          More records available. Click the "Last Page" button again to fetch the next batch (up to {{ FETCH_TO_END_BATCH_LIMIT }} records).
        </div>
        
        <!-- Sorting data notification -->
        <div *ngIf="isSortingData" style="color: #9C27B0; font-style: italic; padding: 8px 16px; background-color: #F3E5F5; border-left: 4px solid #9C27B0; margin-bottom: 8px; display: flex; align-items: center;">
          <mat-spinner diameter="18" style="margin-right: 8px;"></mat-spinner>
          Sorting data...
        </div>
      </div>
      <div #container class="table-container">
        <table
          class="table"
          mat-table
          matSort
          matSortDisableClear
          #table
          [dataSource]="dataSource"
          [trackBy]="trackByLoan"
          CCMCPerfectScrollbar
        >
          <!-- number Column -->
          <ng-container matColumnDef="checkBox">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef
              class="checkbox"
            ></th>
            <td mat-cell *matCellDef="let element" class="noselect">
              <mat-checkbox
                [(ngModel)]="element.checkToSend"
                (change)="updateCheckedLoans($event, element)"
              ></mat-checkbox>
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <!-- LoanName Column -->
          <ng-container matColumnDef="loanNumber">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="thcss">
              Loan Number
            </th>
            <td mat-cell *matCellDef="let element" class="noselect">
              {{ element.loanNumber }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="thcss">
              Date
            </th>
            <td mat-cell *matCellDef="let element" class="noselect" [matTooltip]="activityTooltip(element)">
              <div class="activity-cell">
                <span>{{ element.date | unixToDate }}</span>
                <span *ngIf="isJustRun(element)" class="just-run-badge">Just ran</span>
                <span *ngIf="!isJustRun(element) && relativeActivity(element)" class="activity-relative">
                  {{ relativeActivity(element) }}
                </span>
              </div>
            </td> 
            <td mat-footer-cell *matFooterCellDef>
              <div *ngIf="isFetchingHistory" style="color: #3FB2C6; font-style: italic;">
                Loading...
              </div>
              <div *ngIf="!isFetchingHistory && isEndOfResults && totalLoaded === 0 && !dataSource.filter" style="color: #3FB2C6; font-style: italic;">
                No history available.
              </div>
              <div *ngIf="!isFetchingHistory && isEndOfResults && isOnLastPage() && !dataSource.filter" style="color: #3FB2C6; font-style: italic;">
                  No more records.
                </div>
            </td>
          </ng-container>
          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="thcss">
              Status
            </th>
            <td mat-cell *matCellDef="let element" class="noselect" [matTooltip]="statusTooltip(element)">
              <!-- getStatusLabel qualifies an in-flight trailing run as
                   "Retrieving - Trailing Docs". The class bindings and the spinner
                   stay on the is* helpers, which compare against the plain phase,
                   so a trailing run styles and animates like any other. -->
              <span class="status-cell"
                    [class.status-in-progress]="isInProgress(element)"
                    [class.status-queued]="isQueued(element)"
                    [class.status-transferring]="isTransferring(element)"
                    [class.status-successful]="isSuccessful(element)"
                    [class.status-partial]="isPartialSuccess(element)"
                    [class.status-unsuccessful]="isUnsuccessful(element)">
                <mat-spinner *ngIf="isInProgress(element)"
                             class="status-spinner"
                             [diameter]="14"
                             [strokeWidth]="2"
                             aria-hidden="true"></mat-spinner>
                <mat-icon *ngIf="isSuccessful(element)" class="status-icon" aria-hidden="true">check_circle</mat-icon>
                <mat-icon *ngIf="isPartialSuccess(element)" class="status-icon" aria-hidden="true">warning</mat-icon>
                <mat-icon *ngIf="isUnsuccessful(element)" class="status-icon" aria-hidden="true">error</mat-icon>
                <span>{{ getStatusLabel(element) }}</span>
              </span>
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>
          <!-- Processed Column -->
          <ng-container matColumnDef="processed">
            <th mat-header-cell *matHeaderCellDef class="thcss" style="color: #3fb2c6; padding-right: 1em;">
              Processed
            </th>
            <td mat-cell *matCellDef="let element" class="noselect" [matTooltip]="trailingDocFileDispersement(element, 'processed')">
              {{ processedFileCount(element) }}
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>
          <!-- Transmitted Column -->
          <ng-container matColumnDef="transmitted">
            <th mat-header-cell *matHeaderCellDef class="thcss" style="color: darkgreen; padding-right: 1em;">
              Transmitted
            </th>
            <td mat-cell *matCellDef="let element" class="noselect" [matTooltip]="trailingDocFileDispersement(element, 'transmitted')">
              {{ transmittedFileCount(element) }}
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>
          <!-- Pending Column -->
          <ng-container matColumnDef="pending">
            <th mat-header-cell *matHeaderCellDef class="thcss" style="color: rgb(100, 77, 0); padding-right: 1em;">
              Pending
            </th>
            <td mat-cell *matCellDef="let element" class="noselect" [matTooltip]="trailingDocFileDispersement(element, 'pending')">
              {{ pendingFileCount(element) }}
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>
          <!-- Failed Column -->
          <ng-container matColumnDef="failed">
            <th mat-header-cell *matHeaderCellDef class="thcss" style="color: red; padding-right: 1em;">
              Failed
            </th>
            <td mat-cell *matCellDef="let element" class="noselect" [matTooltip]="trailingDocFileDispersement(element, 'failed')">
              {{ failedFileCount(element) }}
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (dblclick)="onSelectLoan(row); exportButtonSwitch = !exportButtonSwitch; resetCheckedFiles()"
            matTooltip="Double Click to see files"
            matTooltipClass="tooltip-color"
            [ngClass]="{ 'accent-50-bg': row == selectedLoan }"
            matTooltip="Double click on the highlighted loan to view loan documents"
            matTooltipClass="tooltip-color"
          ></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator #paginator
        [pageSize]="currentPageSize"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
    <!-- Selected Loan View -->
    <div
      class="selected-loan-container"
      [ngStyle]="{ display: !showSelectedLoanView ? 'none' : 'inherit' }"
    >
      <app-selected-loan [checkedFiles]="checkedFiles" 
        (checkedFilesChanged)="updateCheckedFiles($event)"
        [(isAllBoxesChecked)]="isAllSelectLoanBoxesChecked"
        (loanSelectVisibleChange)="updateLoanSelectVisibility($event)"
        [(settings)]="settings"
        ></app-selected-loan>
    </div>
  </div>

  <div
    style="
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 999999;
    "
    *ngIf="showSpinner"
  >
    <mat-spinner></mat-spinner>
  </div>
</div>
